// long_text: a white rounded textarea. Saves on blur.

import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import {
  FieldError,
  FieldHelper,
  FieldLabel,
  textareaClass,
  textRules,
} from "./chrome";
import { V2FieldProps } from "./types";

export default function LongTextField({ field, onCommit }: V2FieldProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={field.ref}
      rules={textRules(field)}
      render={({ field: rhf, fieldState: { error } }) => (
        <div>
          <FieldLabel
            text={field.title}
            htmlFor={field.ref}
            optional={!field.required}
          />
          <textarea
            id={field.ref}
            name={rhf.name}
            ref={rhf.ref}
            rows={4}
            value={rhf.value ?? ""}
            placeholder={field.placeholder}
            maxLength={field.maxLength}
            className={textareaClass(Boolean(error))}
            onChange={rhf.onChange}
            onBlur={() => {
              rhf.onBlur();
              onCommit();
            }}
          />
          <FieldHelper text={field.description} />
          <FieldError message={error?.message} />
        </div>
      )}
    />
  );
}
